import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadSetor() {
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodsetor, setedtcodsetor] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext(); 

  const handleOpen = (cad) => {
    setedtcodsetor(cad.codsetor);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarSetor() {

    api
      .get("/v1/cadastro/setor", {
        params: {
          busca: abusca,
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarSetor();
    },
    [showform, abusca, selectedCompany]
  );

  function Cadastrar() {
    api
      .post(
        "/v1/cadastro/setor",
        {
          descricao: edtdescricao,
          ativo: edtativo,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarSetor();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/setor",
        {
          codsetor: edtcodsetor,
          descricao: edtdescricao,
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarSetor();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/setor", {
        params: {
          codsetor: edtcodsetor,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarSetor();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodsetor(0);
    setedtdescricao("");
    setedtativo("S");
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodsetor(cad.codsetor);
    setedtdescricao(cad.descricao);
    setedtativo(cad.ativo);
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-2">
                        <div>
                          <label htmlFor="ativo1" className="form-label">
                            Ativo
                          </label>
                          <br />
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="ativo"
                              value="S"
                              onChange={(e) => setedtativo(e.target.value)}
                              checked={edtativo === "S"}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio1"
                            >
                              Sim
                            </label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="ativo"
                              value="N"
                              onChange={(e) => setedtativo(e.target.value)}
                              checked={edtativo === "N"}
                            />
                            <label className="form-check-label" htmlfor="ativo2">
                              Não
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de Setor</h1>
            <p className="ms-4">Rotina para cadastrar os setores da Empresa</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou descrição"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codsetor}>
                      <th>{item.codsetor}</th>
                      <th>{item.descricao}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadSetor;
